var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: [
        { "alert-success": _vm.isOpen, "alert-danger": !_vm.isOpen },
        "big-alert",
      ],
      style: { fontSize: _vm.fontSize },
      attrs: { role: "alert" },
    },
    [
      _c("strong", { attrs: { title: _vm.iconOnly ? _vm.alertText : "" } }, [
        _c("i", { staticClass: "fa fa-exclamation-circle" }),
      ]),
      _vm._v("\n    " + _vm._s(_vm.iconOnly ? "" : _vm.alertText) + "\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }